import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext } from "react";
const cursorContext = createContext(null);
const Provider = cursorContext.Provider;
export const CursorContextProvider = ({ value, children, }) => {
    return _jsx(Provider, { value: value, children: children });
};
export const useCursorContext = () => {
    const context = React.useContext(cursorContext);
    if (context === null) {
        throw new Error("useCursorContext must be used within a CursorContextProvider");
    }
    return context;
};
//# sourceMappingURL=cursorContext.js.map